// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================
   Custom component theme — the ONLY place colours, borders,
   radius and sizes are defined. Every Custom* component reads
   these variables, so changing a value here restyles all of them.
   ========================================================== */

:root {
  /* ---- brand ---- */
  --cui-primary: #4f5fe8;
  --cui-primary-hover: #4351d6;
  --cui-primary-light: #6f7bf0;
  --cui-primary-soft: #eef0ff;
  --cui-primary-soft-hover: #e0e3ff;
  --cui-primary-border: #c9d0fa;
  --cui-primary-ring: rgba(79, 95, 232, 0.14);

  /* ---- status ---- */
  --cui-danger: #d92d20;
  --cui-danger-hover: #b42318;
  --cui-danger-soft: #fef3f2;
  --cui-danger-soft-hover: #fee4e2;
  --cui-danger-border: #fda29b;
  --cui-danger-ring: rgba(217, 45, 32, 0.14);

  --cui-success: #067647;
  --cui-success-soft: #ecfdf3;
  --cui-success-border: #abefc6;

  --cui-warning: #b54708;
  --cui-warning-soft: #fffaeb;
  --cui-warning-border: #fedf89;

  --cui-info: #026aa2;
  --cui-info-soft: #f0f9ff;
  --cui-info-border: #b9e6fe;

  /* ---- text ---- */
  --cui-text: #131a2c;
  --cui-text-label: #2b3446;
  --cui-text-muted: #667085;
  --cui-text-placeholder: #98a0b3;
  --cui-text-on-primary: #ffffff;

  /* ---- surfaces & borders ---- */
  --cui-bg: #ffffff;
  --cui-bg-subtle: #f8fafc;
  --cui-bg-hover: #f3f5f9;
  --cui-bg-disabled: #f3f5f9;
  --cui-border: #d7dbe3;
  --cui-border-hover: #b9c0f5;
  --cui-border-soft: #e6e9f0;
  --cui-border-width: 1.5px;

  /* ---- shape & size ---- */
  --cui-radius-sm: 6px;
  --cui-radius: 10px;
  --cui-radius-lg: 14px;
  --cui-control-height: 40px;
  --cui-control-padding-x: 12px;
  --cui-font-size: 13px;
  --cui-font-size-sm: 11.5px;
  --cui-label-size: 13px;
  --cui-field-gap: 6px;
  --cui-field-margin: 14px;

  /* ---- elevation ---- */
  --cui-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px -6px rgba(15, 23, 42, 0.08);
  --cui-shadow-md: 0 12px 28px -12px rgba(15, 23, 42, 0.18);
  --cui-shadow-lg: 0 24px 60px -16px rgba(15, 23, 42, 0.32);

  /* ---- layering ----
     modal 1300 · table confirm 3000 · table filter drawer 4000 ·
     dropdown menus 5000 (always on top of whatever opened them) */
  --cui-z-modal: 1300;

  --cui-transition: 0.15s ease;
}

/* Small screens: slightly larger touch targets, 16px text stops iOS zooming on focus */
@media (max-width: 576px) {
  :root {
    --cui-control-height: 44px;
    --cui-font-size: 14px;
  }
}

/* ==========================================================
   Shared control style — used by input, textarea, date picker
   and the dropdown trigger so every field looks identical.
   ========================================================== */

.cui-control {
  width: 100%;
  min-height: var(--cui-control-height);
  padding: 8px var(--cui-control-padding-x);
  font-family: inherit;
  font-size: var(--cui-font-size);
  line-height: 1.4;
  color: var(--cui-text);
  background: var(--cui-bg);
  border: var(--cui-border-width) solid var(--cui-border);
  border-radius: var(--cui-radius);
  outline: none;
  box-sizing: border-box;
  transition: border-color var(--cui-transition), box-shadow var(--cui-transition),
    background var(--cui-transition);
}

.cui-control::placeholder {
  color: var(--cui-text-placeholder);
}

.cui-control:hover:not(:disabled):not(.cui-control-error) {
  border-color: var(--cui-border-hover);
}

.cui-control:focus,
.cui-control-focused {
  border-color: var(--cui-primary);
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.cui-control:disabled,
.cui-control-disabled {
  background: var(--cui-bg-disabled);
  color: var(--cui-text-placeholder);
  cursor: not-allowed;
}

/* Error state: red border + red focus ring, everywhere */
.cui-control-error,
.cui-control-error:hover {
  border-color: var(--cui-danger);
}

.cui-control-error:focus,
.cui-control-error.cui-control-focused {
  border-color: var(--cui-danger);
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

/* Visually hidden but readable by screen readers */
.cui-srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomTheme/customTheme.css"],"names":[],"mappings":"AAAA;;;;+DAI+D;;AAE/D;EACE,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,2CAA2C;;EAE3C,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;EAC5B,0CAA0C;;EAE1C,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;;EAE7B,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;;EAE7B,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;;EAE1B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;;EAE9B,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;;EAEzB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;;EAExB,wBAAwB;EACxB,yFAAyF;EACzF,yDAAyD;EACzD,yDAAyD;;EAEzD;;kEAEgE;EAChE,mBAAmB;;EAEnB,4BAA4B;AAC9B;;AAEA,uFAAuF;AACvF;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF;;AAEA;;;+DAG+D;;AAE/D;EACE,WAAW;EACX,qCAAqC;EACrC,yCAAyC;EACzC,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uDAAuD;EACvD,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB;oCACkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["/* ==========================================================\n   Custom component theme — the ONLY place colours, borders,\n   radius and sizes are defined. Every Custom* component reads\n   these variables, so changing a value here restyles all of them.\n   ========================================================== */\n\n:root {\n  /* ---- brand ---- */\n  --cui-primary: #4f5fe8;\n  --cui-primary-hover: #4351d6;\n  --cui-primary-light: #6f7bf0;\n  --cui-primary-soft: #eef0ff;\n  --cui-primary-soft-hover: #e0e3ff;\n  --cui-primary-border: #c9d0fa;\n  --cui-primary-ring: rgba(79, 95, 232, 0.14);\n\n  /* ---- status ---- */\n  --cui-danger: #d92d20;\n  --cui-danger-hover: #b42318;\n  --cui-danger-soft: #fef3f2;\n  --cui-danger-soft-hover: #fee4e2;\n  --cui-danger-border: #fda29b;\n  --cui-danger-ring: rgba(217, 45, 32, 0.14);\n\n  --cui-success: #067647;\n  --cui-success-soft: #ecfdf3;\n  --cui-success-border: #abefc6;\n\n  --cui-warning: #b54708;\n  --cui-warning-soft: #fffaeb;\n  --cui-warning-border: #fedf89;\n\n  --cui-info: #026aa2;\n  --cui-info-soft: #f0f9ff;\n  --cui-info-border: #b9e6fe;\n\n  /* ---- text ---- */\n  --cui-text: #131a2c;\n  --cui-text-label: #2b3446;\n  --cui-text-muted: #667085;\n  --cui-text-placeholder: #98a0b3;\n  --cui-text-on-primary: #ffffff;\n\n  /* ---- surfaces & borders ---- */\n  --cui-bg: #ffffff;\n  --cui-bg-subtle: #f8fafc;\n  --cui-bg-hover: #f3f5f9;\n  --cui-bg-disabled: #f3f5f9;\n  --cui-border: #d7dbe3;\n  --cui-border-hover: #b9c0f5;\n  --cui-border-soft: #e6e9f0;\n  --cui-border-width: 1.5px;\n\n  /* ---- shape & size ---- */\n  --cui-radius-sm: 6px;\n  --cui-radius: 10px;\n  --cui-radius-lg: 14px;\n  --cui-control-height: 40px;\n  --cui-control-padding-x: 12px;\n  --cui-font-size: 13px;\n  --cui-font-size-sm: 11.5px;\n  --cui-label-size: 13px;\n  --cui-field-gap: 6px;\n  --cui-field-margin: 14px;\n\n  /* ---- elevation ---- */\n  --cui-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px -6px rgba(15, 23, 42, 0.08);\n  --cui-shadow-md: 0 12px 28px -12px rgba(15, 23, 42, 0.18);\n  --cui-shadow-lg: 0 24px 60px -16px rgba(15, 23, 42, 0.32);\n\n  /* ---- layering ----\n     modal 1300 · table confirm 3000 · table filter drawer 4000 ·\n     dropdown menus 5000 (always on top of whatever opened them) */\n  --cui-z-modal: 1300;\n\n  --cui-transition: 0.15s ease;\n}\n\n/* Small screens: slightly larger touch targets, 16px text stops iOS zooming on focus */\n@media (max-width: 576px) {\n  :root {\n    --cui-control-height: 44px;\n    --cui-font-size: 14px;\n  }\n}\n\n/* ==========================================================\n   Shared control style — used by input, textarea, date picker\n   and the dropdown trigger so every field looks identical.\n   ========================================================== */\n\n.cui-control {\n  width: 100%;\n  min-height: var(--cui-control-height);\n  padding: 8px var(--cui-control-padding-x);\n  font-family: inherit;\n  font-size: var(--cui-font-size);\n  line-height: 1.4;\n  color: var(--cui-text);\n  background: var(--cui-bg);\n  border: var(--cui-border-width) solid var(--cui-border);\n  border-radius: var(--cui-radius);\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color var(--cui-transition), box-shadow var(--cui-transition),\n    background var(--cui-transition);\n}\n\n.cui-control::placeholder {\n  color: var(--cui-text-placeholder);\n}\n\n.cui-control:hover:not(:disabled):not(.cui-control-error) {\n  border-color: var(--cui-border-hover);\n}\n\n.cui-control:focus,\n.cui-control-focused {\n  border-color: var(--cui-primary);\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.cui-control:disabled,\n.cui-control-disabled {\n  background: var(--cui-bg-disabled);\n  color: var(--cui-text-placeholder);\n  cursor: not-allowed;\n}\n\n/* Error state: red border + red focus ring, everywhere */\n.cui-control-error,\n.cui-control-error:hover {\n  border-color: var(--cui-danger);\n}\n\n.cui-control-error:focus,\n.cui-control-error.cui-control-focused {\n  border-color: var(--cui-danger);\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n/* Visually hidden but readable by screen readers */\n.cui-srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
